import Client from "./Clients/AxiosClient";
const resource = "/api/v1/admin/user";

export default {
  get(page = 1, search = "", pageSize = 10, filters = {}) {
    const queryParts = [];

    if (filters?.Cabang) queryParts.push(`cabang:${filters.Cabang}`);
    if (filters?.Gender) queryParts.push(`jenis_kelamin:${filters.Gender}`);
    if (filters?.Kategori) {
      const isPriority = filters.Kategori === "Priority" ? 1 : 0;
      queryParts.push(`is_murid_priority:${isPriority}`);
    }

    const filtersString = queryParts.join(",");

    return Client.get(resource, {
      params: {
        page,
        page_size: pageSize,
        search,
        ...(filtersString && { filters: filtersString }),
      },
    });
  },
  search(search) {
    return Client.get(`${resource}`, { params: { search } });
  },
  show(id) {
    return Client.get(`${resource}/${id}`);
  },
  create(payload) {
    return Client.post(resource, payload);
  },
  update(payload, id) {
    return Client.put(`${resource}/${id}`, payload);
  },
  delete(id) {
    return Client.delete(`${resource}/${id}`);
  },
  resetPassword(id) {
    return Client.put(`${resource}/${id}/reset-password`);
  },
  getPengerjaanHistory(userId, page = 1, pageSize = 10, search = "") {
    return Client.get(`${resource}/${userId}/pengerjaan/history`, {
      params: { page, page_size: pageSize, search },
    });
  },
};
